export default function Logo(): React.ReactElement {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Visual Studio Code</title>
      <path
        d="M45.3867 11.0394L37.1502 7.05074C36.1968 6.58905 35.0575 6.7838 34.3093 7.53634L7.34613 32.2629C6.62089 32.9279 6.62172 34.0764 7.34793 34.7404L9.55036 36.7542C10.1441 37.2971 11.0382 37.337 11.6774 36.8493L44.1473 12.0742C45.2366 11.243 46.8012 12.0245 46.8012 13.3997V13.3035C46.8012 12.3382 46.2514 11.4582 45.3867 11.0394Z"
        fill="#0065A9"
      />
      <g filter="url(#filter0_d_15531_7004)">
        <path
          d="M45.3867 42.5635L37.1502 46.5523C36.1968 47.014 35.0575 46.8192 34.3093 46.0667L7.34613 21.3401C6.62089 20.675 6.62172 19.5266 7.34793 18.8626L9.55036 16.8488C10.1441 16.3059 11.0382 16.2659 11.6774 16.7537L44.1473 41.5288C45.2366 42.3599 46.8012 41.5785 46.8012 40.2033V40.2995C46.8012 41.2648 46.2514 42.1448 45.3867 42.5635Z"
          fill="#007ACC"
        />
      </g>
      <g filter="url(#filter1_d_15531_7004)">
        <path
          d="M37.1518 46.5537C36.1982 47.0151 35.0588 46.8199 34.3105 46.0673C35.2325 46.9946 36.8089 46.3379 36.8089 45.0265V8.57757C36.8089 7.26616 35.2325 6.6094 34.3105 7.53671C35.0588 6.7841 36.1982 6.58907 37.1518 7.05036L45.3869 11.0336C46.2522 11.4521 46.8025 12.3324 46.8025 13.2982V40.306C46.8025 41.2718 46.2522 42.1521 45.3868 42.5706L37.1518 46.5537Z"
          fill="#1F9CF0"
        />
      </g>
      <g style={{mixBlendMode: 'overlay'}} opacity="0.25">
        <path
          opacity="0.25"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.1492 46.6304C35.7787 46.8771 36.4967 46.8613 37.1321 46.5537L45.3621 42.5706C46.2269 42.1521 46.7769 41.2718 46.7769 40.306V13.2982C46.7769 12.3324 46.227 11.4521 45.3621 11.0336L37.1321 7.05036C36.2982 6.64673 35.3221 6.7456 34.5902 7.28081C34.4856 7.35727 34.386 7.44263 34.2925 7.53671L18.5372 21.994L11.6745 16.7544C11.0356 16.2666 10.142 16.3066 9.54869 16.8495L7.34759 18.8633C6.62183 19.5273 6.621 20.6757 7.3458 21.3408L13.2974 26.802L7.3458 32.2633C6.621 32.9283 6.62183 34.0768 7.34759 34.7408L9.54869 36.7546C10.142 37.2974 11.0356 37.3374 11.6745 36.8497L18.5372 31.6101L34.2925 46.0674C34.5418 46.3182 34.8344 46.5071 35.1492 46.6304ZM36.7894 17.6748L24.8347 26.802L36.7894 35.9292V17.6748Z"
          fill="url(#paint0_linear_15531_7004)"
          style={{mixBlendMode: 'overlay'}}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15531_7004"
          x="0.000237465"
          y="9.61059"
          width="53.6035"
          height="43.9922"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.40125" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow_15531_7004" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15531_7004" result="shape" />
        </filter>
        <filter
          id="filter1_d_15531_7004"
          x="27.508"
          y="0.000237465"
          width="26.0967"
          height="53.6035"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.40125" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow_15531_7004" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15531_7004" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_15531_7004"
          x1="26.7898"
          y1="6.80273"
          x2="26.7898"
          y2="46.8013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
